import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-predictive-maintainance',
  templateUrl: './predictive-maintainance.component.html',
  styleUrls: ['./predictive-maintainance.component.css','../animate.css/animate.min.css',
  "../aos/aos.css",
  "../bootstrap/css/bootstrap.min.css",
  "../bootstrap-icons/bootstrap-icons.css",
  "../boxicons/css/boxicons.min.css",
  "../glightbox/css/glightbox.min.css",
  "../remixicon/remixicon.css",
  "../swiper/swiper-bundle.min.css",
  "../style.css"],
  encapsulation: ViewEncapsulation.None ,
  providers: [NgbCarouselConfig] 
})
export class PredictiveMaintainanceComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  title = 'owlcarouselinAngular';  
  Images = [
      {title: "Energy Monitoring System",text: "Real-time data gathering, analytics & insights help industries reduce their power usage.", img: "assets/img/slide-1.svg",button: "#about"},
      {title: "Level Monitoring System",text: "Optimize demand-supply, free packages in the tank, schedule filling and everything of tanks using real-time data gathering & predicting future demand using analysis.", img: "assets/img/slide-2.svg",button: "#about"},
      {title: "IIOT Software Platform",text: "Energyly's Intelligent analytics & Insights helps   Industries, Restaurants, BFSI and Retail sector, reduce their power usage. Energyly's Intelligent analytics & Insights helps Industries.", img: "assets/img/slide-3.svg",button: "#about"},
      {title: "Predictive Maintenance System",text: "Reduce assests downtime by using AI powered insights of data gathered from IOT Sensor.", img: "assets/img/slide-4.svg",button: "#about"},
      {title: "Wireless 4g Data Logger System",text: "Simple Plug & Play 4G GSM device which takes data from sensors & send it to cloud.", img: "assets/img/slide-5.svg",button: "#about"},
      {title: "Flow Monitoring System",text: "Two-way communication can help turn on-off flow Values remotely. Also gets insights of up to 100 parameters including flow-rate, Totalize, Valve working hours at your fingertips", img: "assets/img/slide-6.svg",button: "#about"},
      {title: "Take Data-Driven Decision",text: "Our IIOT Solution will gather data from senders & push it to the cloud. Analytics on this cloud will help take data-given decisions.", img: "assets/img/slide-7.svg",button: "#about"},
  ];  
  
  SlideOptions = { items: 1, dots: true, nav: true,loop: true,mouseDrag: true,
      touchDrag: true,pullDrag: true,autoplay:true,};  
  CarouselOptions = { items: 3, dots: true, nav: true,loop: true,mouseDrag: true,
      touchDrag: true,pullDrag: true,autoplay:true,}; 

  title1 = 'owlcarouselinAngular';  
  Images1 = [
      {title: "Custom Reporting",text: "", img: "assets/img/blue_bor_search.svg",button: "#about"},
      {title: "Custom Dashboard",text: "", img: "assets/img/blue_bor_takedata.svg",button: "#about"},
      {title: "Custom Alerts",text: "", img: "assets/img/blue_bor_flowmonitor.svg",button: "#about"},
      {title: "2-way communication",text: "", img: "assets/img/2way_communication.svg",button: "#about"},
      {title: "Remote Device Configuration",text: "", img: "assets/img/remote_device.svg",button: "#about"},
      {title: "MQIT Support",text: "", img: "assets/img/mqit.svg",button: "#about"},
      {title: "Easy to install and operate",text: "", img: "assets/img/easyoperater.svg",button: "#about"},
      {title: "End to End IIoT Solution",text: "", img: "assets/img/endsolution.svg",button: "#about"},
      {title: "Real Time Monitoring and Alert",text: "", img: "assets/img/realtime.svg",button: "#about"},
      {title: "Advance Data Analytics",text: "", img: "assets/img/advancedata.svg",button: "#about"},
      {title: "Past Data Access",text: "", img: "assets/img/pastdata.svg",button: "#about"},
      {title: "Allows remote controlling of pumps",text: "", img: "assets/img/allowremote.svg",button: "#about"},
      {title: "Role wise Portal Access",text: "", img: "assets/img/rolewise.svg",button: "#about"},
      {title: "Hierarchical Access",text: "", img: "assets/img/portalmeter.svg",button: "#about"},
  ];  
  
  SlideOptions1 = { items: 5, margin: 10, dots: true, nav: true,mouseDrag: true,
      touchDrag: true,pullDrag: true,autoplay:true,responsive: {
        0: {
          items: 1
        },
        300: {
          items: 3
        },
        400: {
          items: 3
        },
        740: {
          items: 3
        },
        940: {
          items: 5
        }
        },
      };  
  CarouselOptions1 = { items: 3,margin: 10,dots: true, nav: true,mouseDrag: true,
      touchDrag: true,pullDrag: true,autoplay:true,responsive: {
          0: {
            items: 1
          },
          400: {
            items: 2
          },
          740: {
            items: 2
          },
          940: {
            items: 3
          }
        },
       }; 
       SlideOptions3 = { items: 4, margin: 10, dots: true, nav: true,mouseDrag: true,
        touchDrag: true,pullDrag: true,autoplay:true,responsive: {
            0: {
              items: 1
            },
            400: {
              items: 2
            },
            740: {
              items: 3
            },
            940: {
              items: 4
            }
          },
        };  
    CarouselOptions3 = { items: 4,margin: 10,dots: true, nav: true,mouseDrag: true,
        touchDrag: true,pullDrag: true,autoplay:true,responsive: {
            0: {
              items: 1
            },
            400: {
              items: 2
            },
            740: {
              items: 3
            },
            940: {
              items: 4
            }
          },
         }; 
         title2 = 'owlcarouselinAngular';
         Images2 = [
           { title: "FMCG", img: "assets/img/automation.svg" },
           { title: "Sugar Mills", img: "assets/img/Manufacturing Plants.svg" },
           { title: "Oil and Gas", img: "assets/img/oilgas.svg" },
           { title: "Rubber", img: "assets/img/rubber.svg" },
           { title: "Automotive and Aircraft", img: "assets/img/Solar.svg" },
           { title: "Paint", img: "assets/img/paint.svg" },
           { title: "Pulp and Paper Mills", img: "assets/img/pulp.svg" },
           { title: "Waste Water Treatment Plants", img: "assets/img/wastewatertreatment.svg" },
           { title: "Beverage water", img: "assets/img/beverage.svg" },
           { title: "Dairy Industry", img: "assets/img/dairy.svg" },
           { title: "Textile manufacturing", img: "assets/img/textile.svg" },
           { title: "Glass", img: "assets/img/glass.svg" },
           { title: "Metal Production", img: "assets/img/metal.svg" },
           { title: "Chemical Plants", img: "assets/img/chemical.svg" },
           { title: "Semiconductor Industry", img: "assets/img/semiconducter_industries.svg" },
           { title: "Irrigation Systems", img: "assets/img/irrigation_systems.svg" },
         ];
       
         SlideOptions2 = {
           items: 5, margin: 10, dots: true, nav: true, mouseDrag: true,
           touchDrag: true, pullDrag: true, autoplay: true, responsive: {
             0: {
               items: 1
             },
             300: {
               items: 3
             },
             400: {
               items: 3
             },
             740: {
               items: 3
             },
             940: {
               items: 5
             }
           },
         };
         CarouselOptions2 = {
           items: 4, margin: 50, dots: true, nav: true, mouseDrag: true,
           touchDrag: true, pullDrag: true, autoplay: true, responsive: {
             0: {
               items: 1
             },
             300: {
               items: 3
             },
             400: {
               items: 3
             },
             740: {
               items: 3
             },
             940: {
               items: 4
             }
           },
           
         };

         redirecttoHome(){}

         navigatelevelmonitoring(){}
       
         navigateflowmonitoring(){}
       
         navigateblog(){}
       
         navigatecontact(){
          this.router.navigate(['contact'])
        };

}
